export class ICDMedicalSupplyRequestForm {
    concept = null;
    medicalSupplyRequestForm = null;
    note = null;
}